import { format } from "date-fns";
import { motion } from "motion/react";
import { useMemo } from "react";
import { SubmitPreviewImage } from "../components/editor/SubmitPreviewImage";
import { useBackendContext } from "../services/backend/backendContextProvider";
import style from './Stage.module.css';

export const Stage: React.FC = () => {

    const { session } = useBackendContext();

    const submitted = useMemo( () => {

        if ( session?.submitted ) {
            return format( new Date( session.submitted ), "d. M. yyyy H:mm:ss" );
        }

        return undefined;

    }, [session] );

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={style.loading}
        style={{ position: 'absolute', inset: 0 }}
    >
        <div className={style.container}>
            <p>Vaše kresba byla odeslána.</p>

            <p>Vydrž, než jí zpracujeme...</p>

            <SubmitPreviewImage />

            <p>{session?.comment}</p>

            <p>{submitted}</p>

            
        </div>
    </motion.div>
}